<template>
  <div>
    <div class="mx-5 py-5 d-flex justify-space-between">
      <h5>{{this.getBillingDetailsInfoByUserId?"Edit Billing Info":"Billing Info"}}</h5>
      <v-icon @click="close()">mdi-close</v-icon>
    </div>
    <v-card color="#F6F8FC" flat class="px-3">
      <v-form v-model="valid" class="py-2">
        <v-container class="mt-2 text_feild_text">
          <v-text-field
            v-model="billingInfoForm.FirstName"
            label="First name"
            :error-messages="
              $v.billingInfoForm.FirstName.$error
                ? 'First name is required'
                : null
            "
          ></v-text-field>
          <v-text-field
            v-model="billingInfoForm.LastName"
            label="Last name"
            :error-messages="
              $v.billingInfoForm.LastName.$error
                ? 'Last name is required'
                : null
            "
          ></v-text-field>
          <v-text-field
            v-model="billingInfoForm.StreetAddress1"
            label="Street Address1"
            :error-messages="
              $v.billingInfoForm.StreetAddress1.$error
                ? 'Street address is required'
                : null
            "
          ></v-text-field>
          <v-text-field
            v-model="billingInfoForm.StreetAddress2"
            label="Street Address2"
            :error-messages="
              $v.billingInfoForm.StreetAddress2.$error
                ? 'Street address is required'
                : null
            "
          ></v-text-field>
          <v-text-field
            v-model="billingInfoForm.City"
            label="City"
            :error-messages="
              $v.billingInfoForm.City.$error ? 'City is required' : null
            "
          ></v-text-field>
          <v-text-field
            v-model="billingInfoForm.Province"
            label="Province"
            :error-messages="
              $v.billingInfoForm.Province.$error
                ? 'Province is required'
                : null
            "
          ></v-text-field>
          <v-text-field
            v-model="billingInfoForm.ZipCode"
            type="number"
            label="Zip Code"
            :error-messages="
              $v.billingInfoForm.ZipCode.$error
                ? 'Zip code is required'
                : null
            "
          ></v-text-field>
          <v-text-field
            v-model="billingInfoForm.Country"
            label="Country"
            :error-messages="
              $v.billingInfoForm.Country.$error
                ? 'Country is required'
                : null
            "
          ></v-text-field>
          <v-text-field
            type="number"
            v-model="billingInfoForm.PhoneNumber"
            label="Phone Number"
            :error-messages="
              $v.billingInfoForm.PhoneNumber.$error
                ? 'Phone number is required'
                : null
            "
          ></v-text-field>
        </v-container>
      </v-form>
    </v-card>
    <div class="d-flex justify-end mx-5 py-5 pt-8 pb-8">
      <v-btn
        class="px-10 py-6 text_transform"
        color="#A1A3A8"
        text
        @click="close()"
      >
        Cancel
      </v-btn>
      <v-btn
        depressed
        color="primary"
        class="px-14 py-6 text_transform"
        :disabled="btnloader"
        @click="send()"
      >
        <span v-if="btnloader != true"> Save </span>
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </div>
  </div>
</template>
<script>
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  mixins: [validationMixin],
  name: "editteamcomponent",
  components: {
    // VueDropify,
    // vueDropzone: vue2Dropzone,
  },
  computed:{
    ...mapGetters(["GetPreviewUser","getBillingDetailsInfoByUserId"])
  },
  mounted(){
    if(this.getBillingDetailsInfoByUserId){
      this.billingInfoForm.FirstName = this.getBillingDetailsInfoByUserId.FirstName
      this.billingInfoForm.LastName = this.getBillingDetailsInfoByUserId.LastName
      this.billingInfoForm.StreetAddress1 = this.getBillingDetailsInfoByUserId.StreetAddress1
      this.billingInfoForm.StreetAddress2 = this.getBillingDetailsInfoByUserId.StreetAddress2
      this.billingInfoForm.City = this.getBillingDetailsInfoByUserId.City
      this.billingInfoForm.Province = this.getBillingDetailsInfoByUserId.Province
      this.billingInfoForm.ZipCode = this.getBillingDetailsInfoByUserId.ZipCode
      this.billingInfoForm.Country = this.getBillingDetailsInfoByUserId.Country
      this.billingInfoForm.PhoneNumber = this.getBillingDetailsInfoByUserId.PhoneNumber
      this.billingInfoForm.Id = this.getBillingDetailsInfoByUserId.Id
    }
    this.billingInfoForm.UserId = this.GetPreviewUser.Id
  },
  validations: {
    billingInfoForm: {
      FirstName: {
        required,
      },
      LastName: {
        required,
      },
      StreetAddress1: {
        required,
      },
      StreetAddress2: {
        required,
      },
      City: {
        required,
      },
      Province: {
        required,
      },
      ZipCode: {
        required,
      },
      Country: {
        required,
      },
      PhoneNumber: {
        required,
      },
    },
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      btnloader:false,
      valid: false,
      billingInfoForm: {
        FirstName: "",
        LastName: "",
        StreetAddress1: "",
        StreetAddress2: "",
        City: "",
        Province: "",
        ZipCode: "",
        Country: "",
        PhoneNumber: "",
        UserId: "",
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  methods: {
    send() {
      this.$v.$touch();
      if(this.$v.$invalid){
        return
      }
      // setTimeout(() => {
        this.btnloader = true;
      // }, 100);
      this.$store.dispatch("AddOrUpdateUserBillingDetailInfo",this.billingInfoForm).then(()=>{
        this.btnloader = false;
        this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Edited Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          this.close()
          this.$store.dispatch("GetBillingDetailsInfoByUserId",{id: this.GetPreviewUser.Id})
      })
  //     setTimeout(() => {
  //       this.Membereditdialog = false;
  //       this.billingeditdialog = false;
  //       this.$swal.fire({
  //           toast: true,
  //           position: "top-end",
  //           icon: "success",
  //           title: "Edited Successfully",
  //           showConfirmButton: false,
  //           timer: 1500,
  //         });
  //  this.close()
  //       this.btnloader = false;
  //     }, 2000);
    },
    close() {
      this.$emit("close");
      this.$v.$reset()
    },
  },
};
</script>
<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
.text_feild_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #121212;
}
</style>
